module.exports = __webpack_public_path__ + "static/img/no_eye.b78b06bf.png";